// ApCompanyFilter.js
import { FilterList } from "@mui/icons-material";
import {
  Badge,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Tooltip,
} from "@mui/material";
import React, { useState, useEffect } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function ApCompanyFilter({
  sortingField,        // current applied value (parent)
  setFilter,           // function to trigger refetch
  sortingOrder,
  setSortingField,     // parent setter
  setSortingOrder,
  includeDeleted,
  setIncludeDeleted,
}) {
  // Local state for modal
  const [localSortingField, setLocalSortingField] = useState(sortingField);
  const [localSortingOrder, setLocalSortingOrder] = useState(sortingOrder);
  const [localIncludeDeleted, setLocalIncludeDeleted] = useState(includeDeleted);

  const [open, setOpen] = useState(false);

  // Reset local state to current applied filters (parent values)
  const resetLocalState = () => {
    setLocalSortingField(sortingField);
    setLocalSortingOrder(sortingOrder);
    setLocalIncludeDeleted(includeDeleted);
  };

  const handleOpen = () => {
    // When opening modal, sync local state with current applied filters
    resetLocalState();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOk = () => {
    // Apply local changes to parent state
    if (localSortingField !== sortingField) {
      setSortingField(localSortingField);
    }
    if (localSortingOrder !== sortingOrder) {
      setSortingOrder(localSortingOrder);
    }
    if (localIncludeDeleted !== includeDeleted) {
      setIncludeDeleted(localIncludeDeleted);
    }
    // Trigger refetch
    setFilter(true);
    setOpen(false);
  };

  const handleReset = () => {
    // Reset local state to default values (empty string for fields, NO for includeDeleted)
    setLocalSortingField("");
    setLocalSortingOrder("");
    setLocalIncludeDeleted("NO");
  };

  // Badge count: count active filters from parent state (applied filters)
  const [count, setCount] = useState(0);
  useEffect(() => {
    let totalCount = 0;
    if (sortingField) totalCount++;
    if (sortingOrder) totalCount++;
    if (includeDeleted === "YES") totalCount++;
    setCount(totalCount);
  }, [sortingField, sortingOrder, includeDeleted]);

  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterList />
          </IconButton>
        </Badge>
      </Tooltip>
      <Modal open={open} onClose={handleClose}>
        <Card sx={style} style={{ width: "500px" }}>
          <CardContent>
            <Paper>
              <Grid container spacing={5}>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <InputLabel id="sort-field-label">Select Sorting Field</InputLabel>
                    <Select
                      labelId="sort-field-label"
                      fullWidth
                      id="sort-field"
                      label="Select Sorting Field"
                      onChange={(e) => setLocalSortingField(e.target.value)}
                      value={localSortingField}
                    >
                      <MenuItem disabled value={""}>
                        Select Sorting Field
                      </MenuItem>
                      <MenuItem value="name">Name</MenuItem>
                      <MenuItem value="created_at">Created At</MenuItem>
                      <MenuItem value="updated_at">Updated At</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <InputLabel id="sort-order-label">Select Sorting Order</InputLabel>
                    <Select
                      labelId="sort-order-label"
                      fullWidth
                      id="sort-order"
                      label="Select Sorting Order"
                      onChange={(e) => setLocalSortingOrder(e.target.value)}
                      value={localSortingOrder}
                    >
                      <MenuItem disabled value={""}>
                        Select Sorting Order
                      </MenuItem>
                      <MenuItem value="asc">Ascending</MenuItem>
                      <MenuItem value="desc">Descending</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <InputLabel id="include-deleted-label">Show Deleted</InputLabel>
                    <Select
                      labelId="include-deleted-label"
                      fullWidth
                      id="include-deleted"
                      label="Show Deleted"
                      onChange={(e) => setLocalIncludeDeleted(e.target.value)}
                      value={localIncludeDeleted}
                    >
                      <MenuItem value="NO">No</MenuItem>
                      <MenuItem value="YES">Yes</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Button onClick={handleReset} color="error">
                    Reset All Filters
                  </Button>
                </Grid>
                <Grid
                  container
                  justifyContent={"flex-end"}
                  item
                  xs={12}
                  md={6}
                  lg={6}
                >
                  <Button onClick={handleOk} color="success">
                    OK
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Modal>
    </Paper>
  );
}

export default ApCompanyFilter;